export class FlatRateUnitV10 {
    static constructFromPlainObject(sourceFRU) {
        const fru = new FlatRateUnitV10(sourceFRU.description, sourceFRU.number, sourceFRU.amount, sourceFRU.originalAmount, sourceFRU.comment, sourceFRU.type, sourceFRU.unit);
        fru.setPositionNumber(sourceFRU.positionNumber);
        fru.setSelected(!!sourceFRU.selected);
        return fru;
    }
    constructor(description, number, amount, originalAmount = amount, comment, type, unit) {
        this.description = description;
        this.number = number;
        this.amount = amount;
        this.originalAmount = originalAmount;
        this.comment = comment;
        this.type = type;
        this.unit = unit;
        this.selected = false;
    }
    getComment() {
        return this.comment;
    }
    setComment(comment) {
        this.comment = comment;
    }
    getDescription() {
        return this.description;
    }
    getNumber() {
        return this.number;
    }
    getType() {
        return this.type;
    }
    setType(type) {
        this.type = type;
    }
    getUnit() {
        return this.unit;
    }
    setUnit(unit) {
        this.unit = unit;
    }
    getAmount() {
        return this.amount;
    }
    setAmount(amount) {
        this.amount = amount;
    }
    getOriginalAmount() {
        return this.originalAmount;
    }
    getPositionNumber() {
        return this.positionNumber;
    }
    setPositionNumber(positionNumber) {
        this.positionNumber = positionNumber;
    }
    isSelected() {
        return this.selected;
    }
    setSelected(selected) {
        this.selected = selected;
    }
}
//# sourceMappingURL=flatRateUnitV10.js.map